import moment from "moment";
import {
  APP_ADVANCED_DATE_FORMAT,
  APP_DATE_FORMAT,
  APP_DATE_REVERSE_FORMAT,
  APP_DATE_TIME_FORMAT,
  APP_ISO_DATE_FORMAT,
  APP_ISO_END_DATE_FORMAT,
  APP_ISO_START_DATE_FORMAT,
  NUMBER_EXCEPT_THIS_SYMBOLS,
} from "./Constant";

export const convertNumberPrice = (value: any) => {
  let number = Number(value ? value : 0);
  let plainNumber = number.toFixed(1).replace(/\d(?=(\d{3})+\.)/g, "$&.");
  return plainNumber.substr(0, plainNumber.length - 2);
};

export const checkObject = (value: any) => {
  if (typeof value === "object" && !Array.isArray(value) && value !== null) {
    return true;
  }
  return false;
};

export const formatDateAdvanceToString = (date?: string | Date) => {
  return date ? moment(date).format(APP_ADVANCED_DATE_FORMAT) : "";
};

export const formatDateToDDMMYYYY = (date?: string | Date) => {
  return date ? moment(date).format(APP_DATE_FORMAT) : null;
};

export const formatDateToYYYYMMDD = (date?: string | Date) => {
  return date ? moment(date).format(APP_DATE_REVERSE_FORMAT) : null;
};

export const formatDateDTO = (date?: string | Date) => {
  return date ? moment(date).format(APP_ISO_DATE_FORMAT) : "";
};
export const formatDateFromDTOCustom = (date?: string | Date) => {
  return date ? moment(date).format(APP_ISO_START_DATE_FORMAT) : "";
}
export const formatDateToDTOCustom = (date?: string | Date) => {
  return date ? moment(date).format(APP_ISO_END_DATE_FORMAT) : "";
};

export const removeDiacritics = (str: string) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const numberExceptThisSymbols = (event: any) => {
  return (
    NUMBER_EXCEPT_THIS_SYMBOLS.includes(event?.key) && event.preventDefault()
  );
};

export const newDate = (
  birthYear: number,
  birthMonth = 0,
  birthDay = 1,
  birthHour = 0,
  birthMinute = 0,
  birthSecond = 0
) => {
  birthDay = birthDay <= 0 ? 1 : birthDay;
  return birthYear
    ? new Date(
        birthYear,
        birthMonth - 1,
        birthDay,
        birthHour,
        birthMinute,
        birthSecond
      ).toString()
    : "";
};

export const formatSummaryStatus = (item: any) => {
  return (
    <div
      style={{ backgroundColor: item?.color }}
      className={`text-center text-white rounded spaces px-8 py-4 mt-3 cursor-pointer`}
    >
      <span className="body-normal-1">{`${item?.statusName}: ${item?.summary}`}</span>
    </div>
  );
};

export const formatMoney = (value: number) => {
  if (!value) {
    return 0;
  } else {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
};

export const sumByKey = (array: any[], key: string) =>
  array.reduce((total, item) => total + (Number(item[key]) || 0), 0);

export const formatDateTime = (value?: Date | string, format: string = APP_DATE_TIME_FORMAT) => {
	if (!value) return;

	return moment(value).format(format);
};

export const blobToBase64 = (blob: Blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const base64ImageToBlob = (str: string) => {
  const pos = str.indexOf(';base64,');
  const type = str.substring(5, pos);
  const b64 = str.substring(pos + 8);

  const imageContent = atob(b64);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for(let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }

  return new Blob([buffer], {type: type});
}

export const getPDFURLPreviewFromBase64 = (base64: string) => {
  const blob = base64ImageToBlob(base64);
  const blobPreview = new Blob([blob], {
    type: 'application/pdf',
  });
  return URL.createObjectURL(blobPreview);
}

export const convertToStringWithDelimiter = (value: any[], delimiter = '-') => {
  return value.filter((value) => Boolean(value)).join(` ${delimiter} `);
};

export const getPartOfTime = (value: Date) => {
  const date = new Date(value);
  return {
    day: date.getDate(),
    month: String(date.getMonth() + 1).padStart(2, '0'),
    year: date.getFullYear(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    second: date.getSeconds(),
    milisecond: date.getMilliseconds(),
  }
};